import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Link,
} from '@resy/ui-kitchen';
import Logger from '../../../../../ui-kitchen/src/utils/logger';
import { sanitizeString } from '../../../../../ui-kitchen/src/utils/sanitizeString';

import './AmexDynamicTermsB2B.scss';

class AmexDynamicTermsB2B extends Component {
  static propTypes = {
    $location: PropTypes.shape({
      path: PropTypes.func,
    }).isRequired,
    ResyAmexConfig: PropTypes.shape({
      baseRequestUrl: PropTypes.string.isRequired,
    }).isRequired,
    setDynamicTermsTitle: PropTypes.func.isRequired,
  }

  state = {
    configData: null,
    configDataValue: '',
  };

  componentDidMount() {
    this.fetchConfig();
  }

  fetchConfig = async () => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
      $location,
      setDynamicTermsTitle,
    } = this.props;

    const pathArr = $location.path().split('/');
    let urlValue = '';
    if (pathArr.length === 3) {
      [, , urlValue] = pathArr;
    }

    const configEndPoint = `${baseRequestUrl}DynamicTermsB2B/${urlValue}.json`;
    try {
      const configResponse = await fetch(configEndPoint, {
        method: 'GET',
      });
      const configData = await configResponse.json();
      if (!configData) {
        this.setState({ configDataValue: 'noData' });
      } else {
        this.setState({ configData, configDataValue: 'data' });
        const {
          page_title: pageTitle,
        } = configData;
        setDynamicTermsTitle(pageTitle);
      }
    } catch (err) {
      this.setState({ configDataValue: 'noData' });
      Logger.error('[AmexDynamicTermsB2B] Error:', err);
    }
  }

  validateLink = (configData) => {
    let isValid = true;
    const { link } = configData;
    const linkJSONKeys = ['href', 'aria_label'];

    linkJSONKeys.forEach((key) => {
      if (Object.keys(link).indexOf(key) === -1) {
        isValid = false;
      }
    });

    if (!isValid) {
      Logger.error('[AmexDynamicTermsB2B] Error: href or aria_label field is missing ');
      return false;
    }
    const {
      href, aria_label: ariaLabel,
    } = link;

    if (!href || !ariaLabel) {
      Logger.error('[AmexDynamicTermsB2B] Error: href or aria_label value is null or blank ');
      return false;
    }

    return isValid;
  }

  validateImage = (configData) => {
    let isValid = true;
    const { image } = configData;
    const imageJSONKeys = ['name', 'alt'];
    imageJSONKeys.forEach((key) => {
      if (Object.keys(image).indexOf(key) === -1) {
        isValid = false;
      }
    });

    if (!isValid) {
      Logger.error('[AmexDynamicTermsB2B] Error: name or alt field is missing ');
      return false;
    }

    const {
      name, alt,
    } = image;

    if (!name || !alt) {
      Logger.error('[AmexDynamicTermsB2B] Error: name or alt value is null or blank ');
      return false;
    }

    return isValid;
  }

  isValidFields = (configData) => {
    let isValid = true;
    const resyJSONKeys = ['page_title', 'link', 'image', 'dynamic_content'];
    resyJSONKeys.forEach((key) => {
      if (Object.keys(configData).indexOf(key) === -1) {
        isValid = false;
      }
    });

    if (!isValid) {
      Logger.error('[AmexDynamicTermsB2B] Error: page_title or link or image or dynamic_content  field is missing ');
      return false;
    }
    const {
      page_title: pageTitle, dynamic_content: dynamicContent,
    } = configData;

    if (!pageTitle || !dynamicContent) {
      Logger.error('[AmexDynamicTermsB2B] Error: pageTitle or dynamicContent field is null or blank ');
      return false;
    }

    isValid = this.validateImage(configData) && this.validateLink(configData);

    return isValid;
  }

  render() {
    const {
      configData,
      configDataValue,
    } = this.state;

    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
      $location,
    } = this.props;

    if (configDataValue === 'noData' || (configData && !this.isValidFields(configData))) {
      $location.path('/404');
      return null;
    }

    if (!configData) {
      return null;
    }

    const {
      dynamic_content: dynamicContent,
      link: { aria_label: ariaLabel, href = '' },
      image: { name = '', alt },
    } = configData;

    const sanitizedDynamicContent = sanitizeString(dynamicContent);

    return (
      <section className="AmexDynamicTermsB2B">
        <article>
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <Link
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={ariaLabel}
                >
                  <img
                    src={`${baseRequestUrl}DynamicTermsB2B/logo/${name}`}
                    className="AmexDynamicTermsB2B__logo"
                    alt={alt}
                  />
                </Link>
                <div
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: sanitizedDynamicContent,
                  }}
                />
              </div>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

export default AmexDynamicTermsB2B;
